import React, { PureComponent } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Modal as ModalComponent } from 'reactstrap';

import { buttonsV2 as Buttons } from '@breezeway/brzw-components';

import { CLASS_NAME, POSITION, TOGGLE_TYPE } from './constants';
import './basic_confirm_modal.scss';

const { BUTTON_SIZES, BUTTON_THEMES } = Buttons.constants;

class BasicConfirmModal extends PureComponent {
  constructor(props) {
    super(props);

    this.onConfirm = this.onConfirm.bind(this);
    this.onToggle = this.onToggle.bind(this);
    this.renderFooter = this.renderFooter.bind(this);
    this.renderHeader = this.renderHeader.bind(this);
    this.renderSubHeader = this.renderSubHeader.bind(this);
  }

  onConfirm() {
    const { isLoading, onConfirm, onToggle } = this.props;

    if (!_.isBoolean(isLoading)) {
      onToggle(TOGGLE_TYPE.SUBMIT);
    }

    onConfirm();
  }

  onToggle(type) {
    const { onToggle } = this.props;
    return () => {
      onToggle(type);
    };
  }

  renderHeader() {
    const { title, subHeader, headerClassName } = this.props;
    return (
      <div
        className={classnames(`${CLASS_NAME}__header`, headerClassName, {
          [`${CLASS_NAME}__header--with-sub-header`]: subHeader,
        })}
      >
        <div className={`${CLASS_NAME}__title`}>{title}</div>
        <Buttons.IconButton
          className={`${CLASS_NAME}__close`}
          iconName="close"
          onClick={this.onToggle(TOGGLE_TYPE.CLOSE)}
          size={BUTTON_SIZES.ICON_MEDIUM}
          theme={BUTTON_THEMES.SUBTLE}
        />
      </div>
    );
  }

  renderSubHeader() {
    const { subHeader } = this.props;

    return subHeader;
  }

  renderFooter() {
    const {
      cancelButtonText,
      confirmButtonText,
      confirmButtonTheme,
      footerClassName,
      isLoading,
      showCancelButton,
    } = this.props;

    return (
      <div className={classnames(`${CLASS_NAME}__footer`, footerClassName)}>
        {showCancelButton && (
          <Buttons.TextButton
            className={`${CLASS_NAME}__cancel-button`}
            onClick={this.onToggle(TOGGLE_TYPE.CANCEL)}
            size={BUTTON_SIZES.LARGE}
            theme={BUTTON_THEMES.DEFAULT}
          >
            {cancelButtonText}
          </Buttons.TextButton>
        )}
        <Buttons.TextButton
          className={`${CLASS_NAME}__confirm-button`}
          onClick={this.onConfirm}
          size={BUTTON_SIZES.LARGE}
          theme={confirmButtonTheme}
          isLoading={isLoading}
        >
          {confirmButtonText}
        </Buttons.TextButton>
      </div>
    );
  }

  render() {
    const { modalClassName, body, className, wrapClassName, bodyClassName, position } = this.props;

    return (
      <ModalComponent
        backdropClassName={`${CLASS_NAME}__backdrop`}
        className={classnames(CLASS_NAME, className, {
          [`${CLASS_NAME}--${position}`]: position,
        })}
        isOpen
        modalClassName={modalClassName}
        toggle={this.onToggle(TOGGLE_TYPE.CLOSE)}
        wrapClassName={classnames(`${CLASS_NAME}__wrapper`, wrapClassName)}
        zIndex={3000}
      >
        {this.renderHeader()}
        {this.renderSubHeader()}
        <div className={classnames(`${CLASS_NAME}__body`, bodyClassName)}>{body}</div>
        {this.renderFooter()}
      </ModalComponent>
    );
  }
}

BasicConfirmModal.propTypes = {
  body: PropTypes.node,
  bodyClassName: PropTypes.string,
  cancelButtonText: PropTypes.string,
  className: PropTypes.string,
  confirmButtonText: PropTypes.string,
  confirmButtonTheme: PropTypes.oneOf(_.values(BUTTON_THEMES)),
  footerClassName: PropTypes.string,
  headerClassName: PropTypes.string,
  isLoading: PropTypes.bool,
  modalClassName: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  position: PropTypes.oneOf(_.values(POSITION)),
  showCancelButton: PropTypes.bool,
  subHeader: PropTypes.node,
  title: PropTypes.string.isRequired,
  wrapClassName: PropTypes.string,
};

BasicConfirmModal.defaultProps = {
  body: null,
  bodyClassName: '',
  cancelButtonText: 'Cancel',
  className: '',
  confirmButtonText: 'Confirm',
  confirmButtonTheme: BUTTON_THEMES.DANGER,
  footerClassName: '',
  headerClassName: '',
  isLoading: null,
  modalClassName: '',
  position: POSITION.TOP,
  showCancelButton: true,
  subHeader: null,
  wrapClassName: '',
};

export default BasicConfirmModal;
